import React from 'react';
import './AlertModal.css';

const AlertModal = ({ isOpen, message, onClose, type = 'info' }) => {
  if (!isOpen) return null;

  return (
    <div className="alert-modal-overlay" onClick={onClose}>
      <div className="alert-modal-content" onClick={e => e.stopPropagation()}>
        <div className={`alert-modal-header ${type}`}>
          {type === 'success' && 'Success!'}
          {type === 'error' && 'Error'}
          {type === 'info' && 'Information'}
          {type === 'confirm' && 'Confirm Action'}
        </div>
        <div className="alert-modal-body">
          {message}
        </div>
        <div className="alert-modal-footer">
          {type === 'confirm' ? (
            <>
              <button className="alert-modal-button confirm" onClick={() => onClose(true)}>
                Confirm
              </button>
              <button className="alert-modal-button cancel" onClick={() => onClose(false)}>
                Cancel
              </button>
            </>
          ) : (
            <button className="alert-modal-button" onClick={() => onClose(true)}>
              OK
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
